import AOS from 'aos';
import 'aos/dist/aos.css';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import { register } from 'swiper/element/bundle';
register();

class App {
    constructor() {
        this.body = document.body;
        this.header = document.querySelector('.header');
        this.btnNav = document.querySelector('.btn-nav');
        this.nav = document.querySelector('.nav-primary');
    }

    init() {
        AOS.init();
        this.bindEvents();
        this.parallax();
        this.autoplayVideos();
        Fancybox.bind("[data-fancybox]", {});
    }

    autoplayVideos() {
        const videos = document.querySelectorAll('video[autoplay]');

        videos.forEach(video => {
            video.muted = true;
            video.defaultMuted = true;
            video.loop = true;

            // const logDuration = () => {
            //     if (Number.isFinite(video.duration)) {
            //         console.log('Video duration:', video.duration, 'seconds', video.currentSrc || video.src);
            //     }
            // };

            const handleTimeUpdate = () => {
                if (Number.isFinite(video.duration) && video.currentTime >= video.duration) {
                    video.currentTime = 0;
                    video.play().catch(() => {});
                }
            };

            const handleLoadedMetadata = () => {
                // logDuration();
                video.addEventListener('timeupdate', handleTimeUpdate);
            };

            if (video.readyState >= 1) handleLoadedMetadata();
            else video.addEventListener('loadedmetadata', handleLoadedMetadata, {once: true});

            const play = () => {
                if (video.ended) video.currentTime = 0;
                video.play().catch(() => {});
            };
            const resume = () => window.requestAnimationFrame(play);
            const playOnInteraction = () => {
                video.play()
                    .then(() => {
                        document.removeEventListener('touchstart', playOnInteraction);
                        document.removeEventListener('pointerdown', playOnInteraction);
                    })
                    .catch(() => {});
            };

            if (video.readyState >= 2) play();
            else video.addEventListener('canplay', play, {once: true});

            document.addEventListener('touchstart', playOnInteraction, {passive: true});
            document.addEventListener('pointerdown', playOnInteraction, {passive: true});
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') resume();
            });
            window.addEventListener('pageshow', resume);
            video.addEventListener('pause', () => {
                if (document.visibilityState === 'visible') resume();
            });
        });
    }

    bindEvents() {
        this.btnNav.onclick = e => this.body.classList.toggle('nav-open');
        this.nav?.addEventListener('click', e => {
            if (e.target.closest('a')) this.body.classList.remove('nav-open');
        });

        window.addEventListener('resize', e => {
            if (!window.matchMedia("(max-width: 767px)").matches) {
                this.btnNav.classList.remove('nav-open');
            }
        });

        document.addEventListener('scroll', e => {
            if (window.scrollY > 0) this.header.classList.add('sticky');
            else this.header.classList.remove('sticky');
        });
    }

    parallax() {
        const parallax = document.querySelectorAll('[data-parallax]');

        if (parallax.length == 0) return;

        const parallaxList = Array.from(parallax).map(el => ({
            el,
            section: el.querySelector('[data-target]') || null,
            speed: parseFloat(el.dataset.speed) || 0.3,
            start: parseFloat(el.dataset.start) || 0,
            end: parseFloat(el.dataset.end) || 0,
            active: false,
        }));

        const targets = parallaxList.filter(item => item.section != null);

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const item = targets.find(t => t.el === entry.target);
                if (!item) return;

                item.active = entry.isIntersecting;
                item.section.style.willChange = item.active ? 'transform' : 'auto';
            });
        }, {
            rootMargin: '50% 0px 50% 0px'
        });

        targets.forEach(item => observer.observe(item.el));

        document.addEventListener('scroll', () => {
            targets.forEach(({el, section, speed, start, end, active}) => {
                if (!active) return;

                const rect = el.getBoundingClientRect();
                if ((rect.bottom - end) > 0 && (rect.top < window.innerHeight - start)) {
                    const offset = -rect.top * speed;
                    section.style.transform = `translateY(${offset}px)`;
                }
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', e => new App().init());
